const templateUrl = require('./inactive-subscriptions.html');

module.exports = {
  controller: require('./inactive-subscriptions.controller'),
  templateUrl: templateUrl
};
